import Button from "../../../../designComponents/Button";
import Flex from "../../../../designComponents/Flex";
import Modal from "../../../../designComponents/Modal";
import Typography from "../../../../designComponents/Typography";
import { ReviewFieldNameType, ReviewReport } from "../types";

type Props = {
  isVisible: boolean;
  onClose: () => void;
  recentReviews: ReviewReport[];
  onAccept: () => void;
  loading: boolean;
};

const reviewFields: Record<
  Exclude<ReviewFieldNameType, undefined | "Policy">,
  string
> = {
  Images: "Images",
  Amenities: "Amenities",
  Inventory: "Inventory",
  RefRoom: "Reference Images",
  Rules: "Rules",
};

const AcceptProperty = ({
  isVisible,
  onClose,
  recentReviews,
  onAccept,
  loading,
}: Props) => {
  return (
    <Modal
      isOpen={isVisible}
      onClose={onClose}
      halfWidth
      title="Accept and Publish Property"
    >
      <Typography
        size={"largeTitle"}
        fontWeight="semibold"
        style={{ textAlign: "center" }}
      >
        Are you sure you want to accept and publish this property?
      </Typography>
      <Typography size={"regular"} style={{ textAlign: "center" }}>
        Please note below checklist before accepting property. Make sure you
        have reviewed those fields and have accepted those rejected fields and
        if not reviewed, review gray fields.
      </Typography>
      {Object.entries(reviewFields)?.map(([f, title], index) => {
        const field = recentReviews?.find((x) => x.field === f);
        const isAccepted = field?.status === "ACCEPTED";
        return (
          <Flex key={f}>
            <Typography size={"title"} color={"dark.black"}>
              {index + 1}.
            </Typography>
            <Typography
              size={"title"}
              color={
                field
                  ? isAccepted
                    ? "status.success"
                    : "status.danger"
                  : "dark.neutral_94"
              }
            >
              {title} {field ? (isAccepted ? "[✔️]" : "[❌]") : ""}
            </Typography>
          </Flex>
        );
      })}
      <Flex justifyContent="center" gap={"50px"} margin={"30px 0px 0px"}>
        <Button variant="gray" size="lg" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="lg"
          onClick={onAccept}
          isLoading={loading}
          isDisabled={loading}
        >
          Accept
        </Button>
      </Flex>
    </Modal>
  );
};

export default AcceptProperty;
